export default __webpack_public_path__ + "static/media/C0001.4e447381.png";